import React, { useState } from "react";
import { Form } from "react-bootstrap";

export default function NotificationsTab() {
  const [settings, setSettings] = useState([
    {
      title: "New Hire and Onboarding Notifications",
      desc: "Alerts when a new hire is added to the system.",
      push: true,
      sms: true,
      email: true,
    },
    {
      title: "Time Off and Leave Requests",
      desc: "Notifications when leave requests are approved or rejected.",
      push: false,
      sms: true,
      email: true,
    },
    {
      title: "Employee Performance and Review Updates",
      desc: "Notifications when performance reviews are updated.",
      push: true,
      sms: true,
      email: true,
    },
    {
      title: "Payroll and Compensation",
      desc: "Alerts when payroll is processed or pending approval.",
      push: true,
      sms: true,
      email: true,
    },
    {
      title: "Job Applications and Recruitment",
      desc: "Alerts for new applications or stage updates.",
      push: true,
      sms: true,
      email: true,
    },
  ]);

  const handleToggle = (index, field) => {
    const updated = [...settings];
    updated[index][field] = !updated[index][field];
    setSettings(updated);
  };

  return (
    <div className="notification-container">
      <h5 className="fw-bold mb-4">Notifications</h5>

      {/* HEADER */}
      <div className="notif-header d-none d-md-flex">
        <div className="col-title">Modules</div>
        <div className="col-toggle">Push</div>
        <div className="col-toggle">SMS</div>
        <div className="col-toggle">Email</div>
      </div>

      {/* LIST */}
      {settings.map((item, index) => (
        <div className="notif-row" key={index}>
          <div className="module-info">
            <h6>{item.title}</h6>
            <p>{item.desc}</p>
          </div>

          <div className="toggles">
            <Form.Check
              type="switch"
              checked={item.push}
              onChange={() => handleToggle(index, "push")}
            />
            <Form.Check
              type="switch"
              checked={item.sms}
              onChange={() => handleToggle(index, "sms")}
            />
            <Form.Check
              type="switch"
              checked={item.email}
              onChange={() => handleToggle(index, "email")}
            />
          </div>
        </div>
      ))}
      <style>
          {
               `
               .notification-container {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}

/* HEADER */
.notif-header {
  background: #f1f3f5;
  padding: 12px 15px;
  font-weight: 600;
  border-radius: 6px;
  margin-bottom: 10px;
}

.col-title {
  flex: 1;
}

.col-toggle {
  width: 80px;
  text-align: center;
}

/* ROW */
.notif-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 10px;
  border-bottom: 1px solid #eee;
}

.module-info h6 {
  margin: 0;
  font-weight: 600;
}

.module-info p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #6c757d;
}

/* TOGGLES */
.toggles {
  display: flex;
  gap: 30px;
  align-items: center;
}

/* SWITCH COLOR (orange like image) */
.form-check-input:checked {
  background-color: #f97316;
  border-color: #f97316;
}

/* MOBILE DESIGN */
@media (max-width: 768px) {
  .notif-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .toggles {
    width: 100%;
    justify-content: space-between;
  }

  .toggles::before {
    content: "Push   SMS   Email";
    font-size: 12px;
    color: #6c757d;
    display: block;
    width: 100%;
    margin-bottom: 5px;
  }
}`
          }
      </style>
    </div>
  );
}